import { loadScript } from '@iv/shared/src/load';
import { PlayerType } from '@iv/shared/src/enum';
import { IPlayerInfo } from './interface';

// 初始化参数
export declare interface Options {
  playerInstance?: any;
  type?: PlayerType;
}

export async function createPlayer(options: Options): Promise<IPlayerInfo> {
  const { type, playerInstance } = options;
  if (!window.InteractVideoPlayer?.createPlayer) {
    await loadScript(`${JS_URL}adapter-player.${type}.global.min.js`);
  }
  if (window.InteractVideoPlayer?.createPlayer) {
    return window.InteractVideoPlayer.createPlayer(playerInstance);
  }
  console.log(`adapter-player.${type}，暂不支持`);
}
